<div class="form-holder {{ documentDirection }}" *ngIf="paymentsCardConfig$ | async as paymentsCardConfig">
    <div
        class="form-content"
        [ngClass]="{ 'form-visible': paymethodFormExpanded }"
    >
        <serviceos-ng-alert
            class="error-alert"
            *ngIf="formErrorMessage"
            [type]="'error'"
        >
            {{ formErrorMessage }}
        </serviceos-ng-alert>
        <ul class="list" *ngIf="(paymethods | async)?.length; else noPaymethodsItem">
            <li
                *ngFor="let paymethod of paymethods | async"
                class="item"
                [ngClass]="{ selected: paymethod.default }"
            >
                <div class="left-column">
                    <serviceos-ng-system-icon
                        [icon]="'pinned-deafult-choosed'"
                        (click)="setAsDefault(paymethod)"
                    ></serviceos-ng-system-icon>
                    <span >{{ paymethod.label }}</span>
                </div>
                <div class="right-column">
                    <serviceos-ng-link
                        [type]="'secondary'"
                        [size]="'small'"
                        (click)="deletePaymethod(paymethod.id)"
                    >
                        <span>
                            {{paymentsCardConfig.delete_button_title}}
                        </span>
                    </serviceos-ng-link>
                </div>
            </li>
        </ul>
        <ng-container *ngIf="paymethodFormExpanded">
            <span class="form-label-title">{{paymentsCardConfig.add_form.title}}</span>
            <serviceos-web-payments [paymethodSetup]="paymethodSetup" [selectedTypeOfPayment]="selectedTypeOfPayment"></serviceos-web-payments>
            <div class="row">
                <div class="col-12">
                    <button (click)="onPaymentFormSubmit()">{{paymentsCardConfig.add_form.confirm_button_title}}</button>
                </div>
            </div>
        </ng-container>
        
        <div
            class="add-paymethod-btn-holder row"
            *ngIf="!paymethodFormExpanded && hasPaymentMethods"
        >
            <div class="col-12">
                <serviceos-ng-system-icon
                    [icon]="'plus'"
                ></serviceos-ng-system-icon>
                <serviceos-ng-link
                    [type]="'primary'"
                    [size]="'small'"
                    [font_weight]="'semi-bold'"
                    (click)="onAddNewCard()"
                >
                    {{paymentsCardConfig.add_button_title}}
                </serviceos-ng-link>
            </div>
        </div>
    </div>
    <serviceos-ng-local-loader [showLoader]="showLoader"></serviceos-ng-local-loader>
</div>

<!-- TODO! -->
<ng-template #noPaymethodsItem>
    <!-- <span class="no-paymethods-item">Default address for contact</span> -->
</ng-template>
